import App from "@/App.tsx";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";

const bookingEngineDiv = document.getElementById("bookingEngine");
if (bookingEngineDiv) {
  const root = ReactDOM.createRoot(bookingEngineDiv);
  root.render(
    <React.StrictMode>
      <App rootDiv={bookingEngineDiv as HTMLDivElement} />
    </React.StrictMode>,
  );
}
